var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.getComponent,{tag:"component",attrs:{"headers":_vm.headerWithSumColumn,"values":_vm.values},scopedSlots:_vm._u([{key:"prepend",fn:function(){return [_vm._t("prepend")]},proxy:true},{key:"append",fn:function(){return [_vm._t("append")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }